import { gql } from '@apollo/client'

export const FETCH_ALL_WIDGET_METRICS = gql`
    mutation FetchAllWidgetMetrics($campaignId: String!, $adAccountId: String!, $dateFrom: String, $dateTo: String) {
        fetchAllWidgetMetrics(campaignId: $campaignId, adAccountId: $adAccountId, dateFrom: $dateFrom, dateTo: $dateTo)
    }
`

export const FETCH_AUDIENCE_TARGETING_METRICS = gql`
    mutation FetchAudienceTargetingMetrics($input: FetchMetricsInput!) {
        fetchAudienceTargetingMetrics(input: $input)
    }
`

export const GET_AUDIENCE_TARGETING_METRICS = gql`
    query GetAudienceTargetingMetrics($input: GetStoredMetricsInput!) {
        getAudienceTargetingMetrics(input: $input) {
            id
            adAccountId
            campaignId
            widget
            metricId
            metricName
            metricApiKey
            dataType
            breakdownValue
            value
            dateStart
            dateEnd
            createdAt
            updatedAt
        }
    }
`

export const GET_AGGREGATED_AUDIENCE_METRICS = gql`
    query GetAggregatedAudienceMetrics($campaignId: String!, $widget: String!, $metricId: String) {
        getAggregatedAudienceMetrics(campaignId: $campaignId, widget: $widget, metricId: $metricId) {
            breakdownValue
            metricName
            dataType
            totalValue
            avgValue
            dataPoints
        }
    }
`

export const GET_ALL_METRICS = gql`
    query GetAllMetrics {
        getAllMetrics {
            id
            name
            apiKey
            dataType
            isDefault
        }
    }
`

export const GET_DEFAULT_METRICS = gql`
    query GetDefaultMetrics {
        getDefaultMetrics {
            id
            name
            apiKey
            dataType
            isDefault
        }
    }
`

export const GET_ALL_AUDIENCE_TARGETING_METRICS = gql`
    query GetAllAudienceTargetingMetrics(
        $campaignId: String!
        $adAccountId: String!
        $dateFrom: String
        $dateTo: String
    ) {
        genderMetrics: getAudienceTargetingMetrics(
            input: {
                campaignId: $campaignId
                adAccountId: $adAccountId
                widget: "Gender"
                dateFrom: $dateFrom
                dateTo: $dateTo
            }
        ) {
            id
            adAccountId
            campaignId
            widget
            metricId
            metricName
            metricApiKey
            dataType
            breakdownValue
            value
            dateStart
            dateEnd
            createdAt
            updatedAt
        }
        ageMetrics: getAudienceTargetingMetrics(
            input: {
                campaignId: $campaignId
                adAccountId: $adAccountId
                widget: "Age"
                dateFrom: $dateFrom
                dateTo: $dateTo
            }
        ) {
            id
            adAccountId
            campaignId
            widget
            metricId
            metricName
            metricApiKey
            dataType
            breakdownValue
            value
            dateStart
            dateEnd
            createdAt
            updatedAt
        }
        deviceMetrics: getAudienceTargetingMetrics(
            input: {
                campaignId: $campaignId
                adAccountId: $adAccountId
                widget: "Device"
                dateFrom: $dateFrom
                dateTo: $dateTo
            }
        ) {
            id
            adAccountId
            campaignId
            widget
            metricId
            metricName
            metricApiKey
            dataType
            breakdownValue
            value
            dateStart
            dateEnd
            createdAt
            updatedAt
        }
        platformMetrics: getAudienceTargetingMetrics(
            input: {
                campaignId: $campaignId
                adAccountId: $adAccountId
                widget: "Platform"
                dateFrom: $dateFrom
                dateTo: $dateTo
            }
        ) {
            id
            adAccountId
            campaignId
            widget
            metricId
            metricName
            metricApiKey
            dataType
            breakdownValue
            value
            dateStart
            dateEnd
            createdAt
            updatedAt
        }
        placementMetrics: getAudienceTargetingMetrics(
            input: {
                campaignId: $campaignId
                adAccountId: $adAccountId
                widget: "Placement"
                dateFrom: $dateFrom
                dateTo: $dateTo
            }
        ) {
            id
            adAccountId
            campaignId
            widget
            metricId
            metricName
            metricApiKey
            dataType
            breakdownValue
            value
            dateStart
            dateEnd
            createdAt
            updatedAt
        }
        countryMetrics: getAudienceTargetingMetrics(
            input: {
                campaignId: $campaignId
                adAccountId: $adAccountId
                widget: "Country"
                dateFrom: $dateFrom
                dateTo: $dateTo
            }
        ) {
            id
            adAccountId
            campaignId
            widget
            metricId
            metricName
            metricApiKey
            dataType
            breakdownValue
            value
            dateStart
            dateEnd
            createdAt
            updatedAt
        }
    }
`
